/* eslint-disable quotes */
/* eslint-disable max-lines */
import { Row, Col, Button, Form, FormGroup, Input, Label, Card, Container, Modal, Table } from 'reactstrap';
import { useContext, useState, useEffect } from 'react';
import { Context as AuthContext } from '../../../contexts/AuthContext';
import CommonHeader from '../../../components/Headers/CommonHeader';
import Loa from '../../../services/Loa';
import { useParams, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import CardHeaderTopFormButtons from '../../../components/Cards/CardHeaderTopFormButtons';

import { selectAllOnFocus } from '../../../helpers/selectOnFocus';
const LoaPolicesForm = () => {
  const history = useHistory();
  const { id } = useParams<{ id: string }>();
  const isEdit = !!id;
  const { token, currentSchool }: any = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [name, setName] = useState('');
  const [accrual, setAccrual] = useState(true);
  const [payment_pct, setPayment_pct] = useState<number>(100);

  const [isOpenLoaReasons, setIsOpenLoaReasons] = useState(false);
  const [loa_reasons, setLoaReasons] = useState<string[]>([]);
  const [showLoaReasonsForm, setShowLoaReasonsForm] = useState(false);
  const [loaReasonDescription, setLoaReasonDescription] = useState('');

  useEffect(() => {
    if (id) getById();
  }, [id]);

  const getById = async () => {
    try {
      const result = await Loa(token).loaPolicyShow(currentSchool.value, id);
      const data = result?.data || {};
      if (!data) return;
      setName(data?.name || '');
      setAccrual(data?.accrual !== undefined ? data.accrual : true);
      setPayment_pct(data?.payment_pct || 100);
      setLoaReasons(data?.loa_reasons || []);
    } catch (e: any) {
      console.error(e?.response?.data?.message || 'Request error');
    }
  };

  const handleAddLoaReason = () => {
    if (loaReasonDescription.trim()) {
      setLoaReasons([...loa_reasons, loaReasonDescription.trim()]);
      setLoaReasonDescription('');
      setShowLoaReasonsForm(false);
    }
  };

  const handleDeleteLoaReason = (index: number) => {
    const newReasons = loa_reasons.filter((_, i) => i !== index);
    setLoaReasons(newReasons);
  };

  const handleSubmitLoaReasonForm = (event: any) => {
    event.preventDefault();
    handleAddLoaReason();
  };

  const handleSubmitLoaPolicy = async (event: React.FormEvent) => {
    event.preventDefault();
    if (loading) return;
    setLoading(true);

    try {
      const data: any = {
        name,
        accrual,
        payment_pct,
        loa_reasons,
      };

      if (id) {
        await Loa(token).loaPolicyUpdate(currentSchool.value, id, data);
      } else {
        await Loa(token).loaPolicyCreate(currentSchool.value, data);
      }

      toast.success('Saved Successfully!');
      history.push('/employee-settings');
    } catch (err: any) {
      toast.error(err?.response?.data?.message || 'Error saving LOA policy');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <CommonHeader />
      <Container className="mt--8" fluid>
        <Row>
          <Col className="order-xl-2" xl="12">
            <Card className="bg-secondary shadow">
              <CardHeaderTopFormButtons
                pageTitle="LOA Policies Settings"
                buttons={[
                  {
                    label: 'Back',
                    onClick: (_) => {
                      history.push('/employee-settings');
                    },
                  },
                  {
                    label: 'Save',
                    color: 'success',
                    onClick: (e) => handleSubmitLoaPolicy(e),
                  },
                ]}
              />
              <div className="p-5 pt-2">
                <Form onSubmit={handleSubmitLoaPolicy}>
                  <Row>
                    <Col lg="8">
                      <FormGroup className="d-flex align-items-center">
                        <Label className="form-control-label mb-0 mr-3" htmlFor="input-name" style={{ minWidth: 200 }}>
                          Name
                        </Label>
                        <div className="flex-grow-1">
                          <Input
                            id="input-name"
                            type="text"
                            placeholder="Example: Executive LOA Policy"
                            value={name}
                            onChange={(event) => setName(event.target.value)}
                            required
                            maxLength={255}
                          />
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row className="mt-4">
                    <Col lg="8">
                      <FormGroup className="d-flex align-items-center">
                        <Label className="form-control-label mb-0 mr-3" style={{ minWidth: 200 }}>
                          Time Off Accrual
                        </Label>
                        <div className="d-flex">
                          <div className="form-check form-check-inline mr-4">
                            <Input
                              className="form-check-input"
                              type="radio"
                              name="accrual"
                              id="continue-accruals"
                              value="true"
                              checked={accrual === true}
                              onChange={() => setAccrual(true)}
                              disabled={isEdit}
                            />
                            <Label className="form-check-label ml-2" htmlFor="continue-accruals">
                              Continue accruals
                            </Label>
                          </div>
                          <div className="form-check form-check-inline">
                            <Input
                              className="form-check-input"
                              type="radio"
                              name="accrual"
                              id="pause-accruals"
                              value="false"
                              checked={accrual === false}
                              onChange={() => setAccrual(false)}
                              disabled={isEdit}
                            />
                            <Label className="form-check-label ml-2" htmlFor="pause-accruals">
                              Pause accruals
                            </Label>
                          </div>
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row className="mt-4">
                    <Col lg="8">
                      <FormGroup className="d-flex align-items-center">
                        <Label className="form-control-label mb-0 mr-3" style={{ minWidth: 200 }}>
                          Company Payment Amount
                        </Label>
                        <div className="d-flex align-items-center">
                          <Input
                            type="number"
                            {...selectAllOnFocus}
                            min="0"
                            max="100"
                            step="0.01"
                            value={payment_pct}
                            onChange={(event) => setPayment_pct(Number(event.target.value))}
                            style={{ width: '140px' }}
                            disabled={isEdit}
                          />
                          <span className="ml-2">%</span>
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row className="mt-4">
                    <Col lg="12">
                      <div className="d-flex align-items-center mt-4">
                        <Button className="mr-2" color="primary" size="sm" onClick={() => setIsOpenLoaReasons(true)}>
                          <i className="fas fa-plus" />
                        </Button>
                        <h3 className="p-0 m-0">LOA Reasons</h3>
                      </div>
                    </Col>

                    <Col lg="12" className="d-flex mt-2">
                      {loa_reasons.map((reason, index) => {
                        return (
                          <div
                            key={`loa-reason-${index}`}
                            className="d-flex align-items-center justify-content-center mt-2 mr-2"
                            style={{ border: '1px solid #dddddd', padding: '20px', width: '170px' }}
                          >
                            <h5 className="mb-0">{reason}</h5>
                          </div>
                        );
                      })}
                    </Col>
                  </Row>

                  <Row className="d-flex justify-content-end mt-4">
                    <Button color="success" type="submit" disabled={loading}>
                      {loading ? 'Saving...' : 'Save'}
                    </Button>
                  </Row>
                </Form>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>

      <Modal
        className="modal-dialog-centered modal-lg"
        isOpen={isOpenLoaReasons}
        toggle={() => setIsOpenLoaReasons(false)}
      >
        <div className="p-4">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h4 className="mb-0">LOA Reasons</h4>
            <Button
              color="secondary"
              size="sm"
              onClick={() => setIsOpenLoaReasons(false)}
              style={{ padding: '5px 10px' }}
            >
              <i className="fas fa-times" />
            </Button>
          </div>

          {!showLoaReasonsForm && (
            <div className="mb-4">
              <Button color="primary" onClick={() => setShowLoaReasonsForm(true)}>
                <i className="fas fa-plus" /> Add a Reason
              </Button>
            </div>
          )}

          {showLoaReasonsForm && (
            <div className="mb-4 p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '5px' }}>
              <h6 className="mb-3">Add New Reason</h6>
              <Form onSubmit={handleSubmitLoaReasonForm}>
                <Row>
                  <Col lg="8">
                    <FormGroup>
                      <Label for="reasonDescription">Description</Label>
                      <Input
                        id="reasonDescription"
                        type="text"
                        value={loaReasonDescription}
                        onChange={(e) => setLoaReasonDescription(e.target.value)}
                        placeholder="Enter reason description"
                        required
                      />
                    </FormGroup>
                  </Col>
                  <Col lg="4" className="d-flex align-items-end">
                    <Button color="success" type="submit" className="mr-2">
                      <i className="fas fa-plus" /> Add
                    </Button>
                    <Button
                      color="secondary"
                      onClick={() => {
                        setShowLoaReasonsForm(false);
                        setLoaReasonDescription('');
                      }}
                    >
                      <i className="fas fa-times" /> Cancel
                    </Button>
                  </Col>
                </Row>
              </Form>
            </div>
          )}

          {loa_reasons.length > 0 && (
            <div>
              <h5 className="mb-3">Current Reasons:</h5>
              <Table className="align-items-center table-flush" responsive>
                <tbody>
                  <tr>
                    <th>Description</th>
                    {!isEdit && <th>Action</th>}
                  </tr>
                  {loa_reasons.map((reason, index) => (
                    <tr key={`modal-reason-${index}`}>
                      <td>{reason}</td>
                      <td>
                        <Button
                          color="danger"
                          size="sm"
                          onClick={() => handleDeleteLoaReason(index)}
                          style={{ padding: '2px 6px' }}
                        >
                          <i className="fas fa-trash-alt" />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}

          {loa_reasons.length === 0 && !showLoaReasonsForm && (
            <div className="text-center text-muted py-4">
              <i className="fas fa-info-circle mb-2" style={{ fontSize: '24px' }} />
              <p className="mb-0">No reasons added yet. Click "Add a Reason" to get started.</p>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};

export default LoaPolicesForm;
